import React, { useEffect, useState } from 'react';
import { Grid, styled, TextField, Paper, Button, Typography, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../api';
import { TrackingCardVHM } from '../../../schema/external';

const VHMDetail: React.FC = () => {
  const { id } = useParams();
  const [data, setData] = useState<TrackingCardVHM | null>(null);

  useEffect(() => {
    api.get<TrackingCardVHM>(`bypass/vhm/${id}`).then((res) => {
      const { data } = res;
      if (data) {
        setData(data);
      }
    });
  }, []);

  return (
    <RootContainer>
      <PageHeader text="อุปกรณ์ติดตามพาหนะ" />

      <Button component={Link} to={`/tracking-card`} sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        หมายเลขอุปกรณ์ติดตาม
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'อุปกรณ์ติดตามพาหนะ'}
        </Typography>

        <Box sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="รหัสอุปกรณ์"
                variant="outlined"
                placeholder="รหัสอุปกรณ์"
                value={data?.imei_id ? data.imei_id : ''}
                autoComplete="off"
                disabled={!data?.imei_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่ออุปกรณ์"
                variant="outlined"
                placeholder="ชื่ออุปกรณ์"
                value={data?.Device_name ? data.Device_name : ''}
                autoComplete="off"
                disabled={!data?.Device_name}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชนิดอุปกรณ์"
                variant="outlined"
                placeholder="ชนิดอุปกรณ์"
                value={data?.Device_type ? data.Device_type : ''}
                autoComplete="off"
                disabled={!data?.Device_type}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="สถานะ"
                variant="outlined"
                placeholder="สถานะ"
                value={data?.status ? data.status : ''}
                autoComplete="off"
                disabled={!data?.status}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </RootContainer>
  );
};

export default VHMDetail;

const RootContainer = styled('div')`
  padding: 24px;
`;
